export default class AdvancedTransactionTypes {
  static BANK_FEED = "bankFeed";

  static BILL = "bill";

  static BILL_PAYMENT = "billPayment";

  static CHECK = "check";

  static CREDIT_CARD_CHARGE = "creditCardCharge";

  static CREDIT_CARD_CREDIT = "creditCardCredit";

  static DEPOSIT = "deposit";

  static EXPENSE = "expense";

  static INCOME = "income";

  static PAYMENT = "payment";

  static PURCHASE = "purchase";

  static RECEIVED = "received";

  static RECEIVED_PAYMENT = "receivedPayment";

  static REFUND_RECEIPT = "refundReceipt";

  static SALES_RECEIPT = "salesReceipt";

  static SPENT = "spent";

  static TRANSFER = "transfer";
}
